import React, { useState } from "react";
import { SensorKitAlertFilters, useSensorKitAlertsInfinite } from "@/alerts/api";
import { Button } from "@/components/ui/button";
import { AlertCard } from "./AlertCard";

interface SensorKitAlertsListProps {
  alertFilters: Omit<SensorKitAlertFilters, 'page' | 'pageSize'>;
}

export const SensorKitAlertsList = ({ alertFilters }: SensorKitAlertsListProps) => {
  const [expandedAlertId, setExpandedAlertId] = useState<number | null>(null);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status
  } = useSensorKitAlertsInfinite(alertFilters);

  const handleToggleAlert = (alertId: number) => {
    setExpandedAlertId(expandedAlertId === alertId ? null : alertId);
  };

  // Get total count from first page
  const totalCount = data?.pages[0]?.count || 0;

  // Flatten all alerts from all pages
  const allAlerts = data?.pages.flatMap(page => page.results) || [];

  return (
    <div>
      <h4 className="font-semibold mb-4">Alerts ({totalCount})</h4>

      {status === 'pending' ? (
        <div>Loading alerts...</div>
      ) : status === 'error' ? (
        <div>Error loading alerts</div>
      ) : (
        <>
          <div className="space-y-2">
            {allAlerts.map((alert) => (
              <AlertCard
                key={alert.id}
                alert={alert}
                isExpanded={expandedAlertId === alert.id}
                onToggle={() => handleToggleAlert(alert.id)}
              />
            ))}
          </div>

          {hasNextPage && (
            <div className="mt-4 text-center">
              <Button
                variant="outline"
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? 'Loading...' : 'Load More'}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
